import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _NationalizationPhoto, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { FileService } from "../../../../core/services/FileService";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { Modal } from "../../../theme/Component/Modal";
import { FileInput } from "../../../theme/Component/FileInput";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { MultipleFileInput } from "../../../theme/Component/MultipleFileInput";
import { ImageGrid } from "../../../theme/Component/ImageGrid";


interface Props {
    formType?: number;
    idFormType?: number;
    isModal?: boolean;
    _onChange?: Function;
}

export const NationalizationPhoto = ({ isModal, _onChange, formType, idFormType }: Props) => {

    const { instance, lista, setLista, bean, setBean, validateForm, isMissing, isRequired, addRequiredFields } = useDataBean(_NationalizationPhoto);

    const fileService = new FileService();
    const [uploadedPhotos, setUploadedPhotos] = useState<any[]>([]);

    const modal = useModal("", MODAL_md);
    const modalC = useModal(`Eliminar Firma ${bean.Name}`, MODAL_SM);

    useEffect(() => {
        addRequiredFields(["FormType", "IDFormType", "Name", "Media"])

        getLista()
    }, [formType, idFormType])


    const getLista = () => {
        let props: any = {
            State: 1
        }

        if (formType) props.FormType = formType;
        if (idFormType) props.IDFormType = idFormType;


        instance.getNationalizationPhotoCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                resp.forEach((element: any) => {
                    const mediaContext = element.DataBeanProperties.MediaContext;
                    const media = element.DataBeanProperties.Media;

                    if (mediaContext && media) {
                        element.DataBeanProperties.ImageURL = fileService.getUrlFile(mediaContext, media);
                    } else {
                        element.DataBeanProperties.ImageURL = null;
                    }
                });

                setLista(resp);
            }
        ).catch(err => { toast.error(err) })

    }

    const create = () => {
        let x: any = {
            State: 1,
            IDEmployee: _single.getAccountID(),
        }
        if (formType) x.FormType = formType;
        if (idFormType) x.IDFormType = idFormType;


        setBean(x);
        setUploadedPhotos([]);
        modal.open("Agregar Foto");
    }

    const isEditing = Boolean(bean.IDNationalizationPhoto);

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (
        obj: any,
        options: { validate?: boolean; refresh?: boolean; closeModal?: boolean; rethrow?: boolean } = {}
    ) => {
        const { validate = true, refresh = true, closeModal = true, rethrow = false } = options;

        if (validate && !validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return Promise.resolve();
        }

        return instance.updateNationalizationPhoto(obj).then(
            (resp: any) => {
                if (refresh) getLista();
                if (closeModal) {
                    modal.close();
                    modalC.close();
                }
                return resp;
            }
        ).catch((err: any) => {
            toast.error(err);
            if (rethrow) return Promise.reject(err);
        });
    }

    const updateUploadedPhotos = (uploadedFiles: any[]) => {
        const baseFormType = formType ?? bean.FormType;
        const baseIDFormType = idFormType ?? bean.IDFormType;

        const photos = uploadedFiles.map((uploadedFile) => ({
            State: 1,
            IDEmployee: _single.getAccountID(),
            FormType: baseFormType,
            IDFormType: baseIDFormType,
            Name: uploadedFile.OriginalName ?? uploadedFile.Name ?? uploadedFile.Media,
            Media: uploadedFile.Media,
            MediaContext: uploadedFile.MediaContext,
        }));

        setUploadedPhotos(photos);
    }

    const saveUploadedPhotos = () => {
        const baseFormType = formType ?? bean.FormType;
        const baseIDFormType = idFormType ?? bean.IDFormType;

        if (!baseFormType || !baseIDFormType) {
            toast.error("Debe diligenciar el tipo y el ID del formulario");
            return;
        }

        if (uploadedPhotos.length === 0) {
            toast.info("Debe cargar al menos una imagen");
            return;
        }

        const savePhoto = (index: number) => {
            if (index === uploadedPhotos.length) {
                setUploadedPhotos([]);
                getLista();
                modal.close();
                return;
            }

            const photo = uploadedPhotos[index];

            editaItem({
                ...photo,
                FormType: baseFormType,
                IDFormType: baseIDFormType,
            }, { validate: false, refresh: false, closeModal: false, rethrow: true })
                .then(() => {
                    savePhoto(index + 1);
                })
                .catch(() => {
                    setUploadedPhotos(uploadedPhotos.slice(index));
                });
        }

        savePhoto(0);
    }

    const setValue = (object: any) => {
        setBean(object);
        _onChange?.(object);
    }

    const editPhoto = (object: any) => {
        setValue(object);
        modal.open(`Editar registro fotográfico: ${object.Name ?? "Imagen"}`);
    }

    const confirmDeletePhoto = (object: any) => {
        setValue(object);
        modalC.open(`Eliminar foto: ${object.Name ?? "Imagen"}`);
    }

    const baseComponent = () => {
        return (
            <>
                <ImageGrid
                    items={lista}
                    imageProperty="ImageURL"
                    titleProperty="Name"
                    getKey={(item) => item.IDNationalizationPhoto}
                    getSubtitle={(item) => `ID:${item.IDNationalizationPhoto}`}
                    onAdd={create}
                    onEdit={editPhoto}
                    onDelete={confirmDeletePhoto}
                    canAdd={_single.canCreate()}
                    canEdit={_single.canEdit()}
                    canDelete={_single.canDelete()}
                    addLabel="Agregar fotos"
                    emptyMessage="No hay registros fotográficos"
                />

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={isEditing ? () => { editaItem(bean) } : saveUploadedPhotos}>
                    <>
                        <div className="row">
                            {!formType &&
                                <div className="col-md-12">
                                    <label className={`${isMissing('FormType') ? 'has-error' : ''}`}>Tipo de Formulario{isRequired('FormType') ? <span className="text-danger">*</span> : ''}</label>
                                    <input type="number" className="form-control" value={bean.FormType} onChange={(e) => { setBean({ ...bean, FormType: e.target.value ? Number(e.target.value) : null }) }} />
                                </div>
                            }
                            {!idFormType &&
                                <div className="col-md-12">
                                    <label className={`${isMissing('IDFormType') ? 'has-error' : ''}`}>ID del Formulario {isRequired('IDFormType') ? <span className="text-danger">*</span> : ''}</label>
                                    <input type="number" className="form-control" value={bean.IDFormType} onChange={(e) => { setBean({ ...bean, IDFormType: e.target.value ? Number(e.target.value) : null }) }} />
                                </div>
                            }

                            {!isEditing ? (
                                <div className="col-md-12">
                                    <MultipleFileInput
                                        autoUpload
                                        label="Imágenes"
                                        docAcept="image/jpeg,image/png,image/gif,image/bmp,image/tiff,image/svg+xml"
                                        onCreate={updateUploadedPhotos}
                                    />
                                </div>
                            ) : (
                                <>
                                    <div className="col-md-12">
                                        <label>Nombre del Archivo</label>
                                        <input type="text" name="Name" className="form-control" value={bean.Name ?? ""} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                                    </div>
                                    <div className="col-md-12">
                                        <FileInput
                                            previsualization
                                            label='Documento Adjunto'
                                            Media={bean.Media}
                                            MediaContext={bean.MediaContext}
                                            docAcept="image/jpeg, image/png, image/gif, image/bmp, image/tiff, image/svg+xml"
                                            onCreate={({ Media, MediaContext }) => { setBean({ ...bean, Media: Media, MediaContext: MediaContext }) }}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </>
                </Modal>


                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.Name}</strong>
                </ModalConfirm>
            </>
        )
    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Registros Fotograficos">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}
